import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { geoJSONToGeometry } from '@tmapy/mapcore';
import { LineStringMeasurement } from './LineStringMeasurement';
import { PolygonMeasurement } from './PolygonMeasurement';
export const Measurement = React.memo(({ feature, projection, dispatch }) => {
    const geometry = geoJSONToGeometry(feature.geometry);
    switch (geometry.getType()) {
        case 'LineString': {
            return (_jsx(LineStringMeasurement, { feature: feature, lineString: geometry, projection: projection, dispatch: dispatch }));
        }
        case 'Polygon': {
            return (_jsx(PolygonMeasurement, { feature: feature, polygon: geometry, projection: projection, dispatch: dispatch }));
        }
    }
    console.error('<FeatureMeasurement> Unsupported geom type');
    return null;
});
//# sourceMappingURL=Measurement.js.map